export default {
  sinceJobStart: 'Od začiatku úlohy',
  sinceFirstInBand: 'Od prvej hodnoty v pásme',
};
